/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle,css } from 'styled-components';
import { Layout,Button} from 'antd';
import {
  theme,
  Text,
  Tabs,
  ButtonAnt
} from '@pfmam/pfmam';
import { Container, Box, Banner } from '../styles/globalStyle';
import AppLayout from '../common/layouts/appLayout';
import StatementsComponent from './components/statementsComponent';
import DocumentsComponent from './components/documentsComponent';
import FundDocumentsComponent from './components/fundDocumentsComponent';
import DailyConfirmsComponent from './components/dailyConfirmsComponent';
import UploadFileComponent from './components/uploadFileComponent';
import { DownloadOutlined, FilePdfOutlined, UploadOutlined } from '@ant-design/icons';
import { GetStatementGuide, CheckUploadAccess } from './../actions/actions';
import { useSelector } from 'react-redux';
const { Content } = Layout;

const OverrideTabs = styled(Tabs)`
  .ant-tabs-ink-bar {
    background: ${(props) => props.linkTextColor};
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.linkTextColor};
  }
`;

const HelpfulGuideButton = styled(ButtonAnt)`
  background-color: ${theme.colors.light_blue};
  border: 1px solid ${theme.colors.light_blue};
  padding: 14px 12px;
  display: inline-block;
  align-items: center;
   :hover {
    opacity: 0.6;
    color: ${theme.colors.light_blue};
  }
  :focus,
  :active {
    opacity: 1;
    color: ${theme.colors.light_blue};
    background: none;
  }
  &.ant-btn > .anticon + span,
  &.ant-btn > span + .anticon {
    margin-left: 5px;
  }
  &.ant-btn > .anticon {
    color: ${theme.colors.danger_red};
  }
`;
const LinkButton = styled(Button)`
  padding: 0;
  display: inline-block;
  font-size: ${theme.font_size.size_2xl};
  line-height: 35px;
  color: ${(props) => props.linkTextColor};
  height: 20px;
  border: 0;
  background: none;
  box-shadow: none;
  :hover {
    opacity: 0.6;
    color: ${theme.colors.white};
  }
  :focus,
  :active {
    opacity: 1;
    color: ${theme.colors.white};
    background: none;
  }
  .anticon{
    margin-left: 8px;
    color: ${theme.colors.danger_red};
  }
`;


export const OverrideStyles = createGlobalStyle`
  .helpful-dropdown-menu {
    .ant-dropdown-menu {
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px rgba(0, 0, 0, 0.08);
      border-radius: 2px;
      padding: 4px 0;
      .ant-dropdown-menu-item {
        font-size: ${theme.font_size.size_l};
        line-height: 20px;
        color: ${theme.colors.black_secondary};
        padding: 8px 12px;
        &:hover {
          background: ${theme.colors.light_grey};
        }
        .anticon {
          margin-right: 8px;
        }
      }
    }
  }
  .rc-virtual-list-scrollbar-thumb {
    background: rgb(0, 0, 0, 0.2) !important;
  }
`;
const ContentWrapper = styled(Content)`
  &.show-upload-tab .ant-tabs-nav-list .ant-tabs-tab:nth-last-child(2) {
    margin-left: 580px !important;
  }
  .ant-table {
    border-radius: 4px;
    .ant-table-tbody {
      & > tr {
        cursor: pointer;
        &:hover {
          &.ant-table-row:not(.ant-table-expanded-row) {
            background: linear-gradient(
                0deg,
                rgba(23, 54, 93, 0.07),
                rgba(23, 54, 93, 0.07)
              ),
              ${theme.colors.white};
          }
        }
        & > td {
          vertical-align: top;
          padding: 20px 32px;
          &.ant-table-column-sort {
            background: ${theme.colors.transparent};
          }
        }
        &:last-child {
          & > td {
            border-bottom-color: ${theme.colors.transparent};
          }
        }
      }
    }
    .ant-table-thead {
      & > tr {
        & > th {
          background: ${theme.colors.light_grey};
          font-family: 'Inter';
          padding: 0 32px;
          font-weight: normal;
          line-height: 20px;
          &:not(:last-child) {
            &:not(.ant-table-selection-column) {
              &:not(.ant-table-row-expand-icon-cell) {
                &:not([colspan]) {
                  &::before {
                    background-color: ${theme.colors.transparent};
                  }
                }
              }
            }
          }
        }
      }
    }
    &.ant-table.ant-table-middle {
      .ant-table-thead {
        .ant-table-column-sorters {
          padding: 0;
          .ant-table-column-sorter-inner .anticon {
            color: ${theme.colors.grey_stone};
          }
          .ant-table-column-sorter-up.active,
          .ant-table-column-sorter-down.active {
            color: ${theme.colors.black_sorted};
          }
        }
        .ant-table-column-sorter-inner {
          margin-top: 0;
        }
      }
    }
    .sort-space-none {
      .ant-table-column-sorters {
        justify-content: flex-start;
      }
      .ant-table-column-title {
        flex: 0 0 auto;
      }
      &.flex-end {
        .ant-table-column-sorters {
          justify-content: flex-end;
        }
      }
    }
    .ant-avatar {
      min-width: 40px;
    }
  }
  .ant-table-title {
    padding: 0 !important;
  }
  .ant-table {
    &.ant-table-middle {
      .ant-table-tbody {
        .ant-table-wrapper {
          &:only-child {
            .ant-table {
              margin: -19px -32px;
            }
          }
        }
        .ant-table-container {
          .ant-table-tbody {
            .ant-table-row {
              .ant-table-cell {
                padding: 20px 32px;
                background-color: ${theme.colors.grey_faint};
              }
              &:hover {
                .ant-table-cell {
                  background-color: transparent;
                }
              }
            }
          }
        }
      }
    }
  }
`;

const StatementsDocumentsContainer = () => {
  const [activeTab, setActiveTab] = useState('statements');
  const showMoveFunds = useSelector(
    (state) => state.siteInfo.allowOnlineTransact
  );
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const clientDetails = useSelector(
      (state) => state.programsClientsSlice.selectedClient
    );
  const programId = clientDetails.payload[0].programid;
  const secondary_color = useSelector((state) => state.siteInfo.secondaryColor);
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const [refreshFundDocuments, setRefreshFundDocuments] = useState(false);
  const [hasUploadAccess, setHasUploadAccess] = useState(false);
  const webuserAccessType = useSelector((state) => state.userSlice.webUserType);
  const showUploadedBy = webuserAccessType == 1 || webuserAccessType == 2;
  useEffect(() => {
    if(webuserAccessType == 1 || webuserAccessType == 2){
    CheckUploadAccess()
      .then((response) => {
        if (response.data.HasAccess === true) {
          setHasUploadAccess(true);
        } else {
          setHasUploadAccess(false);
        }
      })
      .catch(() => setHasUploadAccess(false));
  }}, [webuserAccessType]);
  const OnHelpfulGuideButton = (item) => {
    if (item === 'statement') {
    GetStatementGuide()
      .then((response) => {
        if (response.data != null && response.data.length > 0) {
          const arrayBuffer = base64ToArrayBuffer(response.data);
          createAndDownloadBlobFile(arrayBuffer, 'Statement_Guide');
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  };

  function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
  }

  function createAndDownloadBlobFile(body, filename, extension = 'pdf') {
    const blob = new Blob([body],{ type: 'application/pdf' });
    const fileName = `${filename}.${extension}`;
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('target', '_blank');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  return (
    <AppLayout>
      <OverrideStyles />
      <ContentWrapper className={programId !== 999 && programId !== 60  && webuserAccessType !== 0 && hasUploadAccess ? 'show-upload-tab' : ''}>
        <Banner bgcolor={primary_color} height="124px">
          <Box
            display="flex"
            alignitems="center"
            height="100%"
            minwidth="100%"
            width="100%"
            zindex="3"
            position="relative"
            padding="44px 0 36px 0"
          >
            <Container>
              <Box
                display="flex"
                justifycontent="space-between"
                alignitems="flex-start"
                margin="0"
              >
                <Box flex="1">
                  <Text
                    color={`${theme.colors.white}`}
                    fontSize="36px"
                    lineheight="44px"
                    label="Statements & Documents"
                  />
                </Box>
                {/* <Dropdown
                  overlay={
                    <Menu
                      type={'withmenu'}
                      multiple={false}
                      mode={'inline'}
                      onClick={(item) => {
                        onMenuClick(item);
                      }}
                      items={[
                        {
                          title: 'Statement Guide',
                          disabled: false,
                          key: 'statement',
                          icon: <FilePdfOutlined />,
                        },
                        // {
                        //   title: 'IP Statement Guide',
                        //   disabled: false,
                        //   key: 'ip_statement',
                        //   icon: <FilePdfOutlined />,
                        // },
                        // {
                        //   title: 'New Daily Confirm Format',
                        //   disabled: false,
                        //   key: 'daily_format',
                        //   icon: <FilePdfOutlined />,
                        // },
                      ]}
                      color={`${theme.colors.black_secondary}`}
                      width={'230px'}
                    />
                  }
                  placement="bottomRight"
                  trigger={['click']}
                  overlayClassName="helpful-dropdown-menu"
                >
                  <HelpfulGuideButton
                    icon={<FilePdfOutlined />}
                    label="Statement Guide"
                    key='statement'
                    onClick={(item) => {
                      debugger;
                      onMenuClick(item);
                    }}
                    type="secondary"
                  />
                </Dropdown> */}
                {/* <HelpfulGuideButton
                    icon={<FilePdfOutlined />}
                    label="Statement Guide"
                    id='statement'
                    onClick={(item) => {
                      OnHelpfulGuideButton(item);
                    }}
                    type="secondary"
                  /> */}
              <LinkButton
                    type="link"
                    linkTextColor={secondary_color}
                    onClick={(item) => {
                      OnHelpfulGuideButton('statement',item);
                    }}>
          <FilePdfOutlined />
          {'Statement Guide'}
        </LinkButton>
              </Box>
            </Container>
          </Box>
        </Banner>
        <>
        <Tabs
            activeTabColor={primary_color}
            //linkTextColor={primary_color}
            defaultActiveKey={activeTab}
            activeKey={activeTab}
            onTabClick={(key) => { setUploadSuccess(false); setActiveTab(key); }}
            tabsOptions={[
              {
                content: <StatementsComponent recipientType="multiple" />,
                key: 'statements',
                label: 'Statements',
              },
              ...(showMoveFunds
                ? [
                    {
                      content: (
                        <DailyConfirmsComponent recipientType="multiple" />
                      ),
                      key: 'dailyConfirms',
                      label: 'Daily Confirms',
                    },
                  ]
                : []),
              {
                content: <DocumentsComponent />,
                key: 'documents',
                label: 'Documents',
              },
              ...(programId !== 999 && programId !== 60 ? [
                {
                  content: <FundDocumentsComponent refreshFundDocuments={refreshFundDocuments} showUploadedBy={showUploadedBy}  showStatus={showUploadedBy && hasUploadAccess ? true:false} />,
                  key: 'fundDocuments',
                  label: 'Fund Documents',
                },
              ] : []),
              ...(programId !== 999 && programId !== 60  && webuserAccessType !== 0 && hasUploadAccess
                ? [{
                    content: <UploadFileComponent uploadSuccess={uploadSuccess} setUploadSuccess={setUploadSuccess} clientDetails={clientDetails} programId={programId} setActiveTab={setActiveTab} setRefreshFundDocuments={setRefreshFundDocuments} />,
                    key: 'upload',
                    label: <span><UploadOutlined style={{ marginRight: 8 }} />Upload File</span>,
                  }]
                : []),
            ]}
            type="horizontal-tab"
          />

        </>
      </ContentWrapper>
    </AppLayout>
  );
};

export default StatementsDocumentsContainer;
